import { Box, ScaleFactorProvider } from "arkh";
import React, { PropsWithChildren, useMemo } from "react";
import { WidgetLayoutProvider } from "widgets";
import { View } from "react-native";

export function WAPreviewContainer(
  props: PropsWithChildren<{
    h: number;
    w: number;
    unitSize: number;
    scale?: number;
    overflow?: "hidden" | "visible";
  }>
) {
  const scale = props.scale ?? 1;

  const us = props.unitSize * scale;
  const widgetLayout = useMemo(
    () => ({
      height: props.h * us,
      width: props.w * us,
      unitSize: us,
      h: props.h,
    }),
    [props.h, props.w, us]
  );

  const scaleFactorValue = useMemo(() => {
    const baseScaleFactorValue = widgetLayout.unitSize / 236;
    // Cap the scale factor to prevent oversized rendering on high-res screens
    return Math.min(baseScaleFactorValue, 1);
  }, [widgetLayout.unitSize]);

  return (
    <Box space="small">
      <ScaleFactorProvider value={scaleFactorValue}>
        <Box
          style={{
            height: widgetLayout.height,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box style={{ flex: 1 }} shadow="medium">
            <View pointerEvents="none">
              <Box
                style={{
                  width: widgetLayout.width,
                  height: widgetLayout.height,
                  overflow: props.overflow ?? "hidden",
                }}
                color="surface"
                cornerRadius="large"
                pointerEvents="none"
              >
                <WidgetLayoutProvider value={widgetLayout}>
                  {props.children}
                </WidgetLayoutProvider>
              </Box>
            </View>
          </Box>
        </Box>
      </ScaleFactorProvider>
    </Box>
  );
}
